export const TECH_STACK = [
    { title: 'Python', emoji: '🐍' },
    { title: 'PyTorch', emoji: '🔥' },
    { title: 'TensorFlow', emoji: '🧠' },
    { title: 'Scikit-learn', emoji: '📊' },
    { title: 'NumPy', emoji: '🔢' },
    { title: 'Pandas', emoji: '🐼' },
    { title: 'OpenCV', emoji: '👁️' },
    { title: 'Hugging Face', emoji: '🤗' },
    { title: 'Docker', emoji: '🐳' },
    { title: 'Kubernetes', emoji: '☸️' },
    { title: 'Apache Spark', emoji: '⚡' },
    { title: 'Apache Airflow', emoji: '🌀' },
    { title: 'FastAPI', emoji: '🚀' },
    { title: 'PostgreSQL', emoji: '🐘' },
    { title: 'MongoDB', emoji: '🍃' },
    { title: 'Redis', emoji: '💾' },
    { title: 'AWS', emoji: '☁️' },
    { title: 'Git', emoji: '📝' },
    { title: 'React', emoji: '⚛️' },
    { title: 'TypeScript', emoji: '🔷' },
] as const;
